import React from "react";
// import {Link} from 'react-router-dom';

function Utilities() {
  return (
    <>
      {/* // <!-- Container (About Section) -->  */}
      <div id="utilities" className="container-fluid">
        <div className="row">
          <h2 className="heading">$LITTLE Utilities</h2>
          <p className="para-sub utilities_para home_p">
            Benefit from a handful of unique utilities and experience the power<br/>
            of a token that proves its value right from the start
          </p>
        </div>

        <div className="row utility">
          <div className="col-sm-6">
            <ul className="social-network social-circle">
              <li>
                <ul className="social list">
                  <li className="icon-text effecthov">
                    <img src={"images/utility1.png"} alt="utilityyimg" />
                  </li>
                  <li className="utility para">
                    <h3 className="utilities-head">Digital marketplace</h3>
                    <p className="home_p">
                      Use $LITTLE on our digital marketplace, a global
                      <br /> NFT marketplace where $LITTLE is the means of
                      <br /> payment for NFTs from artists all around the globe.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <ul className="social list">
                  <li className="icon-text effecthov">
                    <img src={"images/utility3.png"} alt="utilityyimg" />
                  </li>

                  <li className="utility para">
                    <h3 className="utilities-head">IPCO Possibilities</h3>
                    <p className="home_p">
                      30 days after the NFT mint, $LITTLE will be offered in an<br/>
                      initial private coin offering for $0.15 / $LITTLE and then<br/>
                      listed on an external exchange.
                    </p>
                  </li>
                </ul>
              </li>

              <li>
                <ul className="social list">
                  <li className="icon-text effecthov">
                    <img src={"images/utility5.png"} alt="utilityyimg" />
                  </li>
                  <li className="utility para">
                    <h3 className="utilities-head">Liquidity providing</h3>
                    <p className="home_p">
                      Little Billionaires are providing liquidity of 250,000 USD
                      at<br/> 0.15$ on the external Exchange. 3% of transaction Fees<br/>
                      are used for liquidity as well.
                    </p>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div className="col-sm-6">
            <ul className="social-network social-circle">
              <li>
                <ul className="social list">
                  <li className="icon-text effecthov">
                    <img src={"images/utility2.png"} alt="utilityyimg" />
                  </li>
                  <li className="utility para">
                    <h3 className="utilities-head">Restribution System</h3>
                    <p className="home_p">
                      Receive rewards in MATIC tokens for holding your $LITTLE.<br/>
                      You can make an entry from $LITTLE 2,000 and<br/> receive daily
                      payable rewards in MATIC.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <ul className="social list">
                  <li className="icon-text effecthov">
                    <img src={"images/utility4.png"} alt="utilityyimg" />
                  </li>
                  <li className="utility para">
                    <h3 className="utilities-head">$LITTLE Launchpad</h3>
                    <p className="home_p">
                      Getting access to early-stage sales means a bargain price
                      for the<br/> investors before the public launch on the market.
                      As a $LITTLE<br/> holder, you get access to a specially
                      designed launchpad.
                    </p>
                  </li>
                </ul>
              </li>

              <li>
                <ul className="social list">
                  <li className="icon-text effecthov">
                    <img src={"images/utility6.png"} alt="utilityyimg" />
                  </li>
                  <li className="utility para">
                    <h3 className="utilities-head">Swap function</h3>
                    <p className="home_p">
                      We have developed an internal exchange function that can<br/>
                      be used to easily swap $LITTLE into MATIC and withdraw<br/>
                      them automatically.
                    </p>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default Utilities;
